import TechInfoGrid from './TechInfoGrid';

export default TechInfoGrid;



// WEBPACK FOOTER //
// ./src/components/grids/TechInfoGrid/index.jsx